import i18n from "../../../../utils/ChrI18n";
import getChartConfigTemplate from "../Templates/BarOrColumnChart/utils";

const getChartConfig = function(data) {
  return getChartConfigTemplate({data: data, exportFileName: i18n.t("widgets.published_users.title")});
}

export default getChartConfig;
